import img4 from '../.././Image/img4.PNG'
import img5 from '../.././Image/img5.PNG'
import img6 from '../.././Image/IMG_3191.PNG'



function Application() {
    return (
        <>
            <div className="inline-grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 justify-center place-items-center">

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img4}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div>

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img5}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div>

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img6}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div>


            </div>





            <div className="text-white mx-4 sm:mx-10 md:mx-[80px] font-sans leading-relaxed mt-10 sm:mt-14 md:mt-16">

               <h1 className="text-center text-2xl sm:text-3xl md:text-4xl font-extrabold mb-10 sm:mb-14 md:mb-16 
                    bg-gradient-to-r from-purple-400 to-blue-400 text-transparent bg-clip-text">
                    Design Documentation
                </h1>

                <div className="inline-grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10">



                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">Application Structure Guide</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A document outlining the full architecture of the application screens, navigation flow, modules, user paths, feature distribution, and layout hierarchy.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">Application Content Guidelines</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Formal rules for writing and organizing in-app text labels, messages, notifications, tooltips, and microcopy for clarity, consistency, and better user communication.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">Application Design Framework</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Detailed instructions on app UI elements, spacing, grids, colors, buttons, forms, icons, and the overall visual design system used across all screens.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">App Style Guide</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Defines the application's visual tone, writing style, icon usage, typography scales, and do’s & don’ts to maintain a unified brand feel within the app.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">App UI/UX Standards Manual</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A complete guide for designing user interfaces and interactions, components, gesture patterns, transitions, animations, responsive behavior, and accessibility standards.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">Application Branding Handbook</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A compact overview of how the brand appears inside the app, logo use, color application, hierarchy, interface visuals, and brand-specific UI behaviors.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">Application Component Library</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Includes reusable app components like buttons, cards, lists, form elements, menus, modals, alerts, and interactive widgets to ensure consistent app development.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">Application Identity Manual</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            Explains the app’s visual and functional identity, screen templates, typography rules, icon styles, image usage, and brand-driven UI patterns.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">App Design System & Brand Identity</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A combined manual merging app branding rules with a structured design system supporting designers and developers building multi-feature applications.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">
                        <h2 className="text-xl sm:text-2xl font-semibold text-purple-300">Application Strategy Guide</h2>
                        <p className="text-base sm:text-lg mt-2 text-gray-200">
                            A strategic document focusing on application goals, user journey mapping, feature prioritization, content strategy, performance direction, and implementation roadmap.
                        </p>
                    </div>


                </div>

            </div>
        </>
    );
}

export default Application;